import { PanelSpinner } from '@vkontakte/vkui';
import { createImportCallback, LazyComponent } from '../LazyComponent';
import { EditorProps } from './types';
import styles from './JSONEditor.module.css';

const importCallback = createImportCallback(() => import('./RichEditor'));

export function JSONEditor(props: EditorProps) {
  return (
    <LazyComponent
      {...props}
      importCallback={importCallback}
      importCallbackSelector={(resp) => resp.RichEditor}
      fallback={() => (
        <div className={styles.loading}>
          <PanelSpinner />
        </div>
      )}
    />
  );
}
